import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Answer } from '@app/definitions/interfaces';

@Component({
    selector: 'app-exercise-magic-box',
    templateUrl: './exercise-magic-box.component.html',
    styleUrls: ['./exercise-magic-box.component.scss']
})
export class ExerciseMagicBoxComponent implements OnInit {
    @Input() exerIndex: number;
    @Input() exercise;
    @Input() cardId: number;
    @Input() studentId: number;
    @Input() isAuthorCard: boolean;
    @Input() isAccessCard: boolean;
    @Input() prev_results: Array<any> = [];
    @Output() answered = new EventEmitter();

    exercise_body: Array<any>;
    answer_array: Array<any>;
    student_answer: Array<any>;
    correct_answer: Array<any>;
    answerStr: string;

    constructor() {}

    public ngOnInit(): void {
        this.exercise_body = JSON.parse(this.exercise.text);
        this.answer_array = JSON.parse(this.exercise.answers[0].shortAnswer);
        this.correct_answer = JSON.parse(this.exercise.answers[0].shortAnswer);

        if (this.prev_results) {
            this.prev_results.forEach(item => {
                if (this.exercise.id === item.exercise_id) {
                    this.student_answer = JSON.parse(item.short_answer);
                }
            });
            return;
        }
        this.student_answer = JSON.parse(this.exercise.answers[0].shortAnswer);
    }

    public inputEnter(rowIndex: number, elemIndex: number, value: string): void {
        this.student_answer[rowIndex][elemIndex] = value;
        this.answerStr = JSON.stringify(this.student_answer);
        const exerciseCorrect: boolean = this.compareWithAnswer();
        const answerObject: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: this.answerStr,
            exercise: this.exercise.id,
            correct: exerciseCorrect
        };

        this.answered.emit(answerObject);
    }

    compareWithAnswer() {
        return this.answerStr === JSON.stringify(this.answer_array);
    }

    public isCorrect(rowIndex, elemIndex, elem) {
        return this.correct_answer[rowIndex][elemIndex] !== elem;
    }
}
